<template>
  <div class="overflow-x-hidden">
    <Header />
    <div class="background--alt">
      <div class="container mx-auto flex md:min-h-screen">
        <div class="flex">
          <div
            class="inline-flex flex-col md:flex-row flex-no-wrap md:items-center"
          >
            <div class="md:w-1/2 px-6 md:px-12 flex flex-col md:items-start">
              <img
                class="mt-12 md:mt-0 w-48 lg:w-64"
                src="@/assets/svg/Stories TV.svg"
              />
              <h2
                class="mt-8 text-xl lg:text-3xl max-w-md gt-walsheim-medium leading-tight"
              >
                Here you can log in to StoriesTV app on tvOS to watch Instagram stories, LIVE streams, posts and IGTV on your Apple TV.
              </h2>
              <div
                class="mt-4 text-base lg:text-lg max-w-md open-sans-regular leading-snug"
              >
              How it works:<br>

<br>- Install StoriesTV app on your Apple TV
<br>- Install this app
<br>- Scan the QR code on your iPhone to log in your Instagram account with this app
<br>- Look! All your subscriptions are on your Apple TV
<br>- Watch your subscriptions’ Instagram posts, stories, LIVE streams and IGTV on your Apple TV with no advertising and staying anonymous
<br><br>We inform you that the content which you viewed in our app will not be marked as viewed in the official Instagram app.
              </div>
              <transition appear name="fade">
                <div class="inline-flex flex-row">
                  <a
                    class="mt-8 grow--button"
                    href="https://apps.apple.com/us/app/storiestv/id1563232866"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      class="w-40 cursor-pointer"
                      src="@/assets/svg/app-store.svg"
                    />
                  </a>
                </div>
              </transition>
            </div>
            <div class="md:w-1/2 md:px-16 mt-8 block md:hidden">
              <transition appear name="fade">
                <img
                  class="mt-8 block md:hidden"
                  src="@/assets/img/intro/ScreenApple TV.png"
                />
              </transition>
            </div>
            <div class="md:w-1/2 md:px-19 hidden md:block">
              <transition appear name="fade">
                <img
                  class="hidden md:block"
                  src="@/assets/img/intro/ScreenApple TV.png"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import DonationModal from "@/components/DonationModal.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    DonationModal,
    Footer
  }
};
</script>
